import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
// import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import {
	resetGetAllWalletsList,
	getAllWalletsList
} from "../../redux/actions/getAllWalletsListAction";
// import { makeStyles } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import {
	resetGetCustomerIdAndNameList,
	getCustomerIdAndNameList
} from "../../redux/actions/getCustomerIdAndNameListAction";
import {
	resetUpdateCustomerWallet,
	updateCustomerWalletList
} from "../../redux/actions/updateCustomerWalletAction";
// import EditIcon from "@mui/icons-material/Edit";
import EditIcon from "@mui/icons-material/Edit";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";

// import Tooltip from "@mui/material/Tooltip";
// import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
// import Autocomplete, {
// 	createFilterOptions
// } from "@mui/material/lab/Autocomplete";
import Autocomplete from "@mui/material/Autocomplete";
import { getUsernameContactSuggestion } from "../../redux/actions/getUsernameContactSuggestionAction";
import { getUserNameContactSuggestionList } from "../../redux/actions/partnerGetUserNameContactSuggestionAction"

//new
import {
	getRegenerateToken,
	resetRegenerateToken,
  } from "../../redux/actions/regenerateTokenAction";
 

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const CustomerMaster = () => {
	const classes = useStyles();
	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	// console.log("adminCurrencyList", adminCurrencyList);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const [customerOrmerchantType, setcustomerOrmerchantType] = useState("");
	const [customerOrmerchantName, setcustomerOrmerchantName] = useState("");
	const [currency, setcurrency] = useState("");
	const [getAllWalletsListStatus, setgetAllWalletsListStatus] = useState(false);
	const [editCustomerMerchantID, setEditCustomerMerchantID] = useState("");
	const [open, setOpen] = React.useState(false);
	const [cusId, setCusId] = useState("");
	const [editWalletId, setEditWalletId] = useState("");
	const [editCurrency, setEditCurrency] = useState("");
	const [walletName, setWalletName] = useState("");
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [store, setStore] = useState("");
	const [customerMob, setcustomerMob] = useState('');
	const [customerEmail, setcustomerEmail] = useState('');

	const [getAllWalletsListResArray, setgetAllWalletsListResArray] = useState(
		[]
	);

	const [updateCustomerWalletListStatus, setupdateCustomerWalletListStatus] =
		useState(false);

	const [updateCustomerWalletListArray, setupdateCustomerWalletListArray] =
		useState([]);

	const dispatch = useDispatch();
	const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const getAllWalletsListRes = useSelector(
		({ getAllWalletsList }) => getAllWalletsList
	);
	const getUsernameSuggestionRes = useSelector(
		({ partnerGetUsernameContactSuggestionsLists }) => partnerGetUsernameContactSuggestionsLists
	)
	const customerWalletCurrencyListRes = useSelector(
		({ getCustomerWalletCurrencyList }) => getCustomerWalletCurrencyList
	);

	const getUsernameContactSuggestionRes = useSelector(({ getUsernameContactSuggestion }) => getUsernameContactSuggestion);


	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        const currentFirstRowIndex = page * rowsPerPage;
        const newPage = Math.floor(currentFirstRowIndex / newRowsPerPage);
   
        setRowsPerPage(newRowsPerPage);
        setPage(newPage);
    };

	const handleClose = () => {
		setOpen(false);
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "customerOrmerchantType") {
			setcustomerOrmerchantType(value);
			// Util.verifyNumber(value)
			// 	? setcustomerOrmerchantType(value)
			// 	: setcustomerOrmerchantType(customerOrmerchantType);
		}

		if (name === "customerOrmerchantName") {
			setcustomerOrmerchantName(value);
			// Util.verifyAlphabet(value)
			// 	? setcustomerOrmerchantName(value)
			// 	: setcustomerOrmerchantName(customerOrmerchantName);
		}

		if (name === "currency") {
			setcurrency(value == "Select Currency" ? "" : value);
		}

		if (name === "editCurrency") {
			setEditCurrency(value);
		}

		if (name === "editCustomerMerchantID") {
			setEditCustomerMerchantID(value);
		}

		if (name === "walletName") {
			// setWalletName(value);
			Util.verifyAlphabet(value)
				? setWalletName(value)
				: setWalletName(walletName);
		}
		if (name === "store") {
			setStore(value);
		}
		if (name === 'customerMob') {
			setcustomerMob(value);
		}
		if (name === 'customerEmail') {
			setcustomerEmail(value);
		}
	};

	const getAllWalletsListApi = () => {
		setgetAllWalletsListStatus(true);
		setIsLoading(true);
		const getAllWalletsListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				customerId: customerOrmerchantType.split("-")[0] || "",
				customerName: customerOrmerchantName,
				currency: currency,
				customerMobile: customerMob.split('-')[0] || '',
				customerEmail: customerEmail || ''
			}
		};
		return dispatch(getAllWalletsList(getAllWalletsListReq, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getAllWalletsListApi();
		}
	}, [regenerateTokenRes.data.status]);

	const getAllWalletsListStatusFunc = () => {
		if (getAllWalletsListStatus) {
			if (getAllWalletsListRes.data.status == "success") {
				setIsLoading(false);
				setgetAllWalletsListResArray(
					[].concat(getAllWalletsListRes.data.walletMasterReVOList)
				);
			}
			if (getAllWalletsListRes.data.status == "Failed") {
				console.log("INSIDEPARRTNEID",regenerateTokenRes.data.partnerId)
				NotificationPopups("error", "Failed", getAllWalletsListRes.data.description)
				setIsLoading(false);
				setgetAllWalletsListResArray(getAllWalletsListRes);
				if (
					getAllWalletsListRes.data.description == "session out"
				) {
					console.log("INSIDEPARRTNEIDSSSSS",regenerateTokenRes.data.partnerId)
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getAllWalletsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getAllWalletsListRes.data.status == "failed") {
				console.log('checking execution: ', partnerloginUser );
				NotificationPopups("error", "Failed", getAllWalletsListRes.data.description)
				setIsLoading(false);
				setgetAllWalletsListResArray(getAllWalletsListRes);
				if (getAllWalletsListRes.data.description == "session out") {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				  }
				// if (
				// 	getAllWalletsListRes.data.description == "session out"
				// ) {
				// 	SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				// }
				if (
					getAllWalletsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getAllWalletsListRes.data.status == "NOT FOUND") {
				setIsLoading(false);
				setgetAllWalletsListResArray(getAllWalletsListRes);
				NotificationPopups("error", "Failed", getAllWalletsListRes.data.status)
			}
		}
	};

	useEffect(() => {
		getAllWalletsListStatusFunc();
	}, [getAllWalletsListRes.data.status]);

	useEffect(() => {
		if (getAllWalletsListRes.data.status == "success") {
			setPage(0);
		}
	}, [getAllWalletsListRes.data.status]);

	const editGetCustomerIdAndName = (
		walletName,
		customerId,
		walletId,
		walletCurrency,
		custName,
		store
	) => {
		setWalletName(walletName);
		setEditWalletId(walletId);
		setCusId(customerId);
		setEditCurrency(walletCurrency);
		// setcurrency(walletCurrency);
		setEditCustomerMerchantID(customerId + "-" + custName);
		editGetCustomerIdAndNameReq(customerId);
		setStore(store);
		setOpen(true);
	};

	const editGetCustomerIdAndNameReq = (customerId) => {
		const getCustomerIdAndNameReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				customerNameOrId: customerId
			}
		};

		return dispatch(
			getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken)
		);
	};

	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);

	const updateCustomerWallet = () => {
		setupdateCustomerWalletListStatus(true);
		const updateCustomerWalletReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				customerId: cusId,
				currency: editCurrency,
				walletId: editWalletId,
				walletName: walletName
			}
		};

		return dispatch(
			updateCustomerWalletList(updateCustomerWalletReq, authToken)
		);
	};

	const updateCustomerWalletListRes = useSelector(
		({ updateCustomerWalletList }) => updateCustomerWalletList
	);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const updateCustomerWalletListStatusFunc = () => {
		if (updateCustomerWalletListStatus) {
			if (updateCustomerWalletListRes.data.status == "success") {
				setOpen(false);
				setNotificationOpen(true);
				getAllWalletsListApi();
				setupdateCustomerWalletListArray(updateCustomerWalletListRes.data);
			}
			if (updateCustomerWalletListRes.data.status == "Failed") {
				setOpen(false);
				setNotificationOpen(true);
				setupdateCustomerWalletListArray(updateCustomerWalletListRes.data);
				if (
					updateCustomerWalletListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateCustomerWalletListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (updateCustomerWalletListRes.data.status == "failed") {
				setOpen(false);
				setNotificationOpen(true);
				setupdateCustomerWalletListArray(updateCustomerWalletListRes.data);
				if (
					updateCustomerWalletListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateCustomerWalletListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		updateCustomerWalletListStatusFunc();
	}, [updateCustomerWalletListRes.data.status]);

	const filterOptions = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filteredOptions = options.filter(
			(option) =>
				option.mobile.toLowerCase().includes(inputValue.toLowerCase()) ||
				option.customerMobileOrName.toLowerCase().includes(inputValue.toLowerCase())
		);

		return filteredOptions.slice(0, 20);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status === 'success') {
			const req = {
				actionCustomerMasterRequestVO:
				{
					customerMobileOrName: customerMob,
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				}
			}
			dispatch(getUsernameContactSuggestion(req, authToken));
		}
	}, [regenerateTokenRes.data.status]);

	useEffect(() => {
		if (getCustomerIdAndNameListRes.data.status === "success") {
			// console.log("lissttt", getCustomerIdAndNameListRes.data.currencyList)
		}
	}, [getCustomerIdAndNameListRes.data.status])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getCustomerIdAndNameReq = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					customerNameOrId: ""
				}
			};

			dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
		}
	}, [regenerateTokenRes.data.status]);

	const filterOptionsL = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}

	//name autocomplete
	useEffect(() => {
		if (getUsernameSuggestionRes.data.status === "success") {
			// console.log("lissttt", getUsernameSuggestionRes.data.list)
		}
	}, [getUsernameSuggestionRes.data.status])


	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getUserContactReq = {
				actionCustomerMasterRequestVO: {
					customerMobileOrName: "",
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				}
			}
			dispatch(getUserNameContactSuggestionList(getUserContactReq, authToken))
			// console.log("userContact", getUserContactReq)
		}
	}, [regenerateTokenRes.data.status])


	const filterOptionsN = (options, { inputValue }) => {
		if (inputValue.length < 3) {
			return [];
		}

		const filteredOptionsNames = options.filter(
			(option) =>

				option.customerMobileOrName && option.customerMobileOrName.includes(inputValue)
		);

		return filteredOptionsNames.slice(0, 20);
	}
	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						style={{ padding: "25px", gap: "20px", justifyContent: "right" }}
					>
						{/* <Grid item md={7} sm={12} lg={5}></Grid> */}
						<Grid item md={3} sm={12} xs={12} lg={3}>
							<NavLink to="/index/addNewCustomerWallet">
								<CustomButton
									style={{
										padding: "8px"
									}}
								>
									Add New Customer Wallet
								</CustomButton>
							</NavLink>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						{/* <Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								size="small"
								type="text"
								label="Customer ID"
								fullWidth={true}
								color="primary"
								autoFocus={true}
								name="customerOrmerchantType"
								value={customerOrmerchantType || ""}
								onChange={handleChange}
							/>
						</Grid> */}
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<Autocomplete
								id="combo-box-demo"
								options={[].concat(
									getCustomerIdAndNameListRes.data.currencyList || [""]
								)}
								getOptionLabel={(option) => option}
								filterOptions={filterOptionsL}
								renderInput={(params) => (
									<TextField
										autoFocus
										margin="dense"
										id="name"
										label="Customer ID"
										style={{ marginTop: "3px" }}
										// required
										type="tel"
										fullWidth
										{...params}
										value={customerOrmerchantType}
										name="customerOrmerchantType"
										onBlur={handleChange}
										variant="standard"
										sx={{
											"& .MuiInput-underline:before": {
											  borderBottomColor: "gray", // White color for the underline before focus
											},
											"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
											  borderBottomColor: "gray", // White color on hover
											},
											"& .MuiInput-underline:after": {
											  borderBottomColor: "gray", // White color after focus
											},
										  }}
									/>
								)}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<Autocomplete
								id="combo-box-demo"
								options={[].concat(
									getUsernameSuggestionRes.data.list || [""]
								)}
								getOptionLabel={(option) => option.customerMobileOrName}
								filterOptions={filterOptionsN}
								renderInput={(params) => (
									<TextField
										autoFocus
										margin="dense"
										id="name"
										label="Customer Name"
										style={{ marginTop: "3px" }}
										type="text"
										fullWidth
										{...params}
										value={customerOrmerchantName || ""}
										name="customerOrmerchantName"
										onBlur={handleChange}
										variant="standard"
										InputProps={{
											sx: {
											  "&:before": { borderBottomColor: "gray" }, // before focus
											  "&:after": { borderBottomColor: "gray" },  // after focus
											},
										  }}
										  InputLabelProps={{
											sx: { color: 'gray' }, // Optional: if you want the label to be white
										  }}
									/>
								)}
							/>
						</Grid>
						{/* <Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Customer Name"
								fullWidth={true}
								name="customerOrmerchantName"
								value={customerOrmerchantName || ""}
								onChange={handleChange}
							/>
						</Grid> */}
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Currency"
								fullWidth={true}
								name="currency"
								// value={currency || ""}
								onChange={handleChange}
								variant="standard"
								defaultValue={"Select Currency" || currency}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{adminCurrencyList.success &&
									[]
										.concat(adminCurrencyList.data.currencyList)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "4px 25px" }}
					>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<Autocomplete
								id="combo-box-demo"
								options={[].concat(
									getUsernameContactSuggestionRes.data.list || [""]
								)}
								getOptionLabel={(option) => option.mobile + '-' + option.customerMobileOrName}
								filterOptions={filterOptions}
								renderInput={(params) => (
									<TextField
										margin="dense"
										id="name"
										label="Customer Mobile No."
										type="text"
										fullWidth
										{...params}
										value={customerMob || ""}
										name="customerMob"
										onBlur={handleChange}
										variant="standard"
										// InputProps={{
										// 	sx: {
										// 	  "&:before": { borderBottomColor: "gray" }, // before focus
										// 	  "&:after": { borderBottomColor: "gray" },  // after focus
										// 	},
										//   }}
										//   InputLabelProps={{
										// 	sx: { color: 'gray' }, // Optional: if you want the label to be white
										//   }}
										sx={{
											"& .MuiInput-underline:before": {
											  borderBottomColor: "gray", // White color for the underline before focus
											},
											"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
											  borderBottomColor: "gray", // White color on hover
											},
											"& .MuiInput-underline:after": {
											  borderBottomColor: "gray", // White color after focus
											},
										  }}
									/>
								)}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Customer Email"
								fullWidth
								variant="standard"
								type="text"
								name="customerEmail"
								value={customerEmail || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getAllWalletsListApi}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getAllWalletsListResArray.length == undefined ||
					!getAllWalletsListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Wallet List
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
									style={{ color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Wallet List
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Wallet ID{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Store ID{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Customer ID{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Customer Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Wallet Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Currency
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Mobile No
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Email
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Balance
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>


									<TableBody>
										{getAllWalletsListResArray &&
											[]
												.concat(getAllWalletsListResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={row.walletId}>
														<TableCell align="center">{row.walletId ? row.walletId : '-'}</TableCell>
														<TableCell align="center">{row.storeId ? row.storeId : '-'}</TableCell>
														<TableCell align="center">
															{row.customerId ? row.customerId : '-'}
														</TableCell>
														<TableCell align="center">{row.custName ? row.custName : '-'}</TableCell>
														<TableCell align="center">
															{row.walletName ? row.walletName : '-'}
														</TableCell>
														<TableCell align="center">
															{row.walletCurrency ? row.walletCurrency : '-'}
														</TableCell>
														<TableCell align="center">
															{row.mobile ? row.mobile : '-'}
														</TableCell>
														<TableCell align="center">
															{row.customerEmail ? row.customerEmail : '-'}
														</TableCell>
														<TableCell align="center">
															{row.walletBalance ? row.walletBalance : '-'}
														</TableCell>
														<TableCell align="center">
															{/* <Tooltip title="Edit"> */}
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		editGetCustomerIdAndName(
																			row.walletName,
																			row.customerId,
																			row.walletId,
																			row.walletCurrency,
																			row.custName,
																			row.storeId
																		)
																	}
																>

																	{
																		<EditIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															{/* </Tooltip> */}
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getAllWalletsListResArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
			</Layout>

			<div>
				<Dialog open={open} onClose={handleClose}>
					<DialogTitle>Edit Customer/Merchant Wallet</DialogTitle>
					<DialogContent>
						<TextField
							// defaultValue={"Select Currency"}
							size="small"
							color="primary"
							autoFocus={true}
							type="text"
							label="Customer/Merchant ID*"
							value={editCustomerMerchantID}
							name="editCustomerMerchantID"
							fullWidth={true}
							select
							onChange={handleChange}
							InputProps={{
								sx: {
								  "&:before": { borderBottomColor: "gray" }, // before focus
								  "&:after": { borderBottomColor: "gray" },  // after focus
								},
							  }}
							  InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							  }}
						>
							{(() => {
								if (getCustomerIdAndNameListRes) {
									if (!getCustomerIdAndNameListRes.data.currencyList) {
										return <MenuItem>No Customer/Merchant ID</MenuItem>;
									}
									return []
										.concat(getCustomerIdAndNameListRes.data.currencyList)
										.map((c) => (
											<MenuItem value={c} key={c}>
												{c}
											</MenuItem>
										));
								}
							})()}
						</TextField>

						<TextField
							disabled
							margin="dense"
							id="name"
							label="Store"
							type="name"
							fullWidth
							variant="standard"
							value={store || ""}
							name="store"
							onChange={handleChange}
							InputProps={{
								sx: {
								  "&:before": { borderBottomColor: "gray" }, // before focus
								  "&:after": { borderBottomColor: "gray" },  // after focus
								},
							  }}
							  InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							  }}
						/>

						<TextField
							select
							required
							size="small"
							color="primary"
							autoFocus={true}
							type="text"
							label="Currency"
							fullWidth={true}
							disabled
							name="editCurrency"
							value={editCurrency || ""}
							onChange={handleChange}
							InputProps={{
								sx: {
								  "&:before": { borderBottomColor: "gray" }, // before focus
								  "&:after": { borderBottomColor: "gray" },  // after focus
								},
							  }}
							  InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							  }}
						>
							{adminCurrencyList.success &&
								[]
									.concat(adminCurrencyList.data.currencyList)
									.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
						</TextField>

						<TextField
							margin="dense"
							id="name"
							label="Wallet Name"
							type="name"
							fullWidth
							variant="standard"
							value={walletName || ""}
							name="walletName"
							onChange={handleChange}
							InputProps={{
								sx: {
								  "&:before": { borderBottomColor: "gray" }, // before focus
								  "&:after": { borderBottomColor: "gray" },  // after focus
								},
							  }}
							  InputLabelProps={{
								sx: { color: 'gray' }, // Optional: if you want the label to be white
							  }}
						/>
					</DialogContent>
					<DialogActions>
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={handleClose}
						>
							Cancel
						</CustomButton>
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={updateCustomerWallet}
						>
							Save
						</CustomButton>
						{/* <Button
              style={{
                backgroundColor: "#fff",
                color: "#000",
              }}
              variant="contained"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              style={{
                backgroundColor: "#00b9f5",
                color: "white",
              }}
              variant="contained"
              onClick={updateCustomerWallet}
            >
              Save
            </Button> */}
					</DialogActions>
				</Dialog>
			</div>

			{updateCustomerWalletListArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateCustomerWalletListArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateCustomerWalletListArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateCustomerWalletListArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default CustomerMaster;
